import { render, staticRenderFns } from "./ProductsCards.vue?vue&type=template&id=38cf884c&scoped=true"
import script from "./ProductsCards.vue?vue&type=script&lang=js"
export * from "./ProductsCards.vue?vue&type=script&lang=js"
import style0 from "./ProductsCards.vue?vue&type=style&index=0&id=38cf884c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf884c",
  null
  
)

export default component.exports